// Small self-expiring "NEW" pill for recently shipped features.
//
// Convention (all Kyber suite + MandoMaster): tag every newly shipped feature's
// entry point (nav item, menu link, button, field label) with
//   <NewBadge since="YYYY-MM-DD" />
// using the feature's ship date. The badge renders nothing once 3 weeks (21
// days) have passed, so it cleans itself up — no follow-up edit required.

const NEW_WINDOW_DAYS = 21;

export function isFeatureNew(since) {
  if (!since) return false;
  const shipped = new Date(`${since}T00:00:00Z`).getTime();
  if (Number.isNaN(shipped)) return false;
  return Date.now() < shipped + NEW_WINDOW_DAYS * 24 * 60 * 60 * 1000;
}

export default function NewBadge({ since, className = '' }) {
  if (!isFeatureNew(since)) return null;
  return (
    <span
      title="Recently added"
      className={`inline-flex items-center px-1.5 py-px rounded-full text-[9px] font-bold uppercase tracking-wider leading-none text-white bg-gradient-to-r from-cyan-500 to-fuchsia-500 shadow-[0_0_8px_rgba(6,182,212,0.45)] ${className}`}
    >
      New
    </span>
  );
}
